import {
  TEquipamento,
  TDivisao,
  TLojas,
  TRegionais,
  TCentral,
} from "../features/types";

type TOption = { value: string; children: string };

interface IFactoryFields {
  grupoMonitoria: Array<TOption>;
  typesReport: Array<TOption>;
  reportsByLoja: Array<TOption>;
  niveisDeAcesso: Array<TOption>;
  equipamentos: (data: Array<TEquipamento>) => Array<TOption>;
  unidadesDeMedida: (data: Array<string>) => Array<TOption>;
  divisoes: (data: Array<TDivisao>) => Array<TOption>;
  regionais: (data: Array<TRegionais>) => Array<TOption>;
  lojas: (data: Array<TLojas>) => Array<TOption>;
  centrais: (data: Array<TCentral>) => Array<TOption>;
  grupoMonitoramento: (data: Array<any>) => Array<TOption>;
}

const factoryFieldsByApi = function (
  data: Array<any>,
  { value, children }: TOption,
  initialSelect: string = "selecione",
) {
  const createOptions = data.map((item: any) => ({
    value: item[value],
    children: item[children],
  }));

  createOptions.unshift({ value: "", children: initialSelect });
  return createOptions;
};

const factoryFieldsCentral = (data) => {
  if (!data) return;
  const createOptions = data.map(({ id, modelo, versao }: TCentral) => ({
    value: id,
    children: `Modelo: ${modelo} | ID: ${id} | Versão: ${versao}`,
  }));

  createOptions.unshift({ value: "", children: "Selecione uma central" });
  return createOptions;
};

const grupoMonitoria = [
  { value: "0", children: "Selecione o tipo" },
  { value: "1", children: "Incêndio" },
  { value: "2", children: "Ativos Criticos" },
];

const typesReport = [
  { value: "", children: "Selecione o tipo de arquivo" },
  { value: "pdf", children: "pdf" },
  { value: "word", children: "word" },
  { value: "xls", children: "xls" },
  { value: "xlsx", children: "xlsx" },
];

const reportsByLoja = [
  { value: "", children: "Selecione" },
  {
    value: "RptPtosPanorama",
    children: "Panorama Atual dos Pontos de Monitoramento",
  },
  {
    value: "RptPtosConfig",
    children: "Configuração dos Pontos de Monitoramento",
  },
  {
    value: "RptDispositivos",
    children: "Dispositivos de Monitoramento Instalados",
  },
  {
    value: "RptHistoricosDispositivos",
    children: "Historico de conexão dos dispositivos",
  },
];

export const mapStatus: any = {
  0: "Inativo",
  1: "Ativo",
};

export const mapNiveisDeAcesso: any = {
  "5": "Cliente Loja Individual",
  "6": "Cliente Acesso Geral",
  "7": "Gestão Administrativa",
  "8": "Gestão Master",
  "9": "Coordenador Regional",
  "999": "Técnico",
};

const niveisDeAcesso = [
  { value: "0", children: "selecione uma opção" },
  { value: "5", children: "Cliente Loja Individual" },
  { value: "6", children: "Cliente Acesso Geral" },
  { value: "7", children: "Gestão Administrativa" },
  { value: "8", children: "Gestão Master" },
  { value: "9", children: "Técnico" },
];

const equipamentos = (data: Array<TEquipamento>) =>
  factoryFieldsByApi(
    data,
    { value: "id", children: "nome" },
    "escolha um equipamento",
  );
const unidadesDeMedida = (data: Array<string>) =>
  factoryFieldsByApi(
    data,
    { value: "unidade", children: "unidade" },
    "escolha a unidade",
  );
const divisoes = (data: Array<TDivisao>) =>
  factoryFieldsByApi(data, { value: "id", children: "nome" });
const regionais = (data: Array<TRegionais>) =>
  factoryFieldsByApi(data, { value: "id", children: "nome" });
const lojas = (data: Array<TLojas>) =>
  factoryFieldsByApi(data, { value: "id", children: "nome" });
const grupoMonitoramento = (data: Array<any>) =>
  factoryFieldsByApi(data, { value: "id", children: "nome" });
const centrais = (data: Array<TCentral>) => factoryFieldsCentral(data);

const factoryFields: IFactoryFields = {
  grupoMonitoria,
  typesReport,
  reportsByLoja,
  equipamentos,
  unidadesDeMedida,
  divisoes,
  lojas,
  regionais,
  centrais,
  grupoMonitoramento,
  niveisDeAcesso,
};

export default factoryFields;
